<template>
    <v-container class="change-password" fluid>
        <vue-headful :title="$t('change_password.title') + $t('title')"></vue-headful>
        <HkiaraceBannerFrame :label="$t('change_password.title')">
            <v-form v-model="isFormValid">
                <v-row>
                    <v-col>
                        <v-text-field outlined
                                      class="required"
                                      :label="$t('change_password.current_password')"
                                      :placeholder="$t('change_password.current_password')"
                                      v-model="currentPassword"
                                      :rules="currentPasswordRules"
                                      validate-on-blur
                                      :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                      :type="showCurrentPassword ? 'text' : 'password'"
                                      @click:append="showCurrentPassword = !showCurrentPassword"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field outlined
                                      class="required"
                                      :label="$t('change_password.new_password')"
                                      :placeholder="$t('change_password.new_password')"
                                      v-model="password"
                                      :rules="passwordRules"
                                      validate-on-blur
                                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                      :type="showPassword ? 'text' : 'password'"
                                      @click:append="showPassword = !showPassword"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field outlined
                                      class="required"
                                      :label="$t('change_password.confirm_password')"
                                      :placeholder="$t('change_password.confirm_password')"
                                      v-model="confirmPassword"
                                      :rules="confirmPasswordRules"
                                      validate-on-blur
                                      :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                      :type="showCurrentPassword ? 'text' : 'password'"
                                      @click:append="showCurrentPassword = !showCurrentPassword"></v-text-field>
                    </v-col>
                </v-row>
            </v-form>
            <v-row>
                <v-col>
                    <v-btn :disabled="!isFormValid"
                           color="primary"
                           @click="changePassword">{{$t('change_password.title')}}</v-btn>
                </v-col>
            </v-row>
        </HkiaraceBannerFrame>
    </v-container>
</template>

<script>
    import HkiaraceBannerFrame from "../../components/HkiaraceBannerFrame";
    export default {
        name: 'Login',
        components: {HkiaraceBannerFrame},
        data() {
            return {
                isFormValid: false,

                currentPassword: '',
                currentPasswordRules: [
                    value => !!value || this.$t('register.enter_required_field'),
                ],
                showCurrentPassword: false,

                password: '',
                passwordRules: [
                    value => (!!value && value.length >= 8) || this.$t('register.password_contain_eight_characters'),
                    value => (!!value && !!this.password.match(/[A-Za-z]/g)) || this.$t('register.password_contain_letters'),
                    value => (!!value && !!this.password.match(/[0-9]/g)) || this.$t('register.password_contain_numbers'),
                    value => (!!value && !!this.password.match(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g) && !value.match(/[ ]/g)) || this.$t('register.password_contain_special_characters'),
                ],
                showPassword: false,

                confirmPassword: '',
                confirmPasswordRules: [
                    value => (!!this.password && value === this.password) || this.$t('register.password_match'),
                ],
                showConfirmPassword: false,
            };
        },
        watch: {},
        computed: {
            passwordContainsEightCharacters() {
                return this.password && this.password.length >= 8;
            },
            passwordContainsLetter() {
                return !!this.password.match(/[A-Za-z]/g);
            },
            passwordContainsNumbers() {
                return !!this.password.match(/[0-9]/g);
            },
            passwordContainsSpecialCharacter() {
                return !!this.password.match(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g) && !this.password.match(/[ ]/g);
            },
            passwordValid() {
                return this.passwordContainsEightCharacters && this.passwordContainsLetter && this.passwordContainsNumbers && this.passwordContainsSpecialCharacter && this.password === this.confirmPassword;
            },
        },
        methods: {
            changePassword() {
                this.$callAPI('hkiarace/change_password/', {current_password: this.currentPassword, new_password: this.password}, function (response) {
                    this.$showAlertMessage(this.$t('change_password.success_msg'));
                    // this.$storeDispatch('logout');
                    this.$router.push({name: 'my-account'});
                });
            },
        }
    }
</script>

<style lang="less">
    .change-password {
        text-align: left;

        .change-password-title {
            font-weight: bold;
            font-size: 1.3rem;
        }

        .password-criteria {
            padding-left: 15px;
            font-size: 90%;

            .fa-check {
                color: green;
            }
            .fa-times {
                color: red;
            }
        }

        .form-control {
            border-radius: 0;
            border: none;
            border-bottom: 1px solid #ced4da;
        }

        .change-password-btn {
            width: 100%;
            background-color: #3b3a53;
            border-color: #3b3a53;
            color: white;
            font-weight: bold;
        }

        .forgot-pw-link {
            color: #798188;
        }
    }
</style>